// extracted by mini-css-extract-plugin
export default {"container":"overlaySpinner_container__zJr8a","background":"overlaySpinner_background__D8-sQ"};